var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"current"}},[_c('app-description'),_c('app-details')],1)}
var staticRenderFns = []

export { render, staticRenderFns }